import { APP_URL } from "../constants/app-url"

const isAbsoluteUrl = (p: string) => p.startsWith("//") || /^https?:\/\//.test(p)

/**
 * Makes an authenticated GET request to a platform API endpoint.
 * @param path - API path (e.g., "/platform/userinfo"), or an absolute URL
 * @param userToken - Bearer token for authorization
 * @returns Parsed JSON response
 */
export async function authorizedGet(path: string, userToken: string) {
  const url = isAbsoluteUrl(path) ? path : `${APP_URL}${path}`
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${userToken}`
    }
  })
  return response.json()
}

/**
 * Builds the application config API URL based on environment.
 * Returns absolute localhost devtool URL on local, or a relative path
 * (resolved against APP_URL by authorizedGet) otherwise.
 */
export function getApplicationsUrl(globalTenantId: string): string {
  if (window.location.hostname === "localhost") {
    return "//localhost:9009/api/applications"
  }
  const param =
    globalTenantId === "00000000-0000-0000-0000-000000000000"
      ? "?applicationType=superAdmin"
      : ""
  return `/api/applications${param}`
}
